import { reportInstallFailed, reportInstallRequestFired, reportInstallSuccess } from '../bi/bi';
import { useAdvanceOauth } from './useAdvanceOauth';
import { INSTALLER_ERRORS } from '../errors';
import { wait } from '../utils/general';
import isEmpty from 'lodash/isEmpty';
import { convertResponseToProvisionSuccess } from '../utils/provision';
import { useHandleError } from '../components/ErrorBoundary/ErrorHandlerProvider';
import { usePanorama } from '../context/PanoramaContext';
import { useInstallerContext } from '../context/InstallerContext';
import { setIsBulkInstallTriggered } from '../selectors/bulk-installer-triggered';
import { useEffect } from 'react';
import { useProvisionApis } from './useProvisionApis';
import { getExperiments } from '../services/experiments';
export const useProvisionApp = () => {
  const {
    appId,
    tenantId,
    setIsFinishLoading,
    preInstallationData,
    onProvisionSuccess,
    shareUrlId
  } = useInstallerContext();
  const {
    panoramaLogger
  } = usePanorama();
  const {
    isAdvancedOauthApp
  } = preInstallationData;
  const {
    handleError
  } = useHandleError();
  const getOauth2 = useAdvanceOauth();
  const {
    installWithShareUrlId,
    installWithAppId
  } = useProvisionApis();
  useEffect(() => {
    return () => {
      setIsBulkInstallTriggered(false); // reset on unmount of the installer
    };
  }, []);
  return async () => {
    reportInstallRequestFired();
    const oauth2 = isAdvancedOauthApp ? await getOauth2() : {};
    if (isAdvancedOauthApp && !oauth2) {
      return; // handle error in useAdvanceOauth hook - don't continue the flow
    }
    const isNewApiForShareUrlEnabled = getExperiments().enabled('spec.dcc.enableNewApiForShareUrl');
    try {
      setIsBulkInstallTriggered(true);
      let installationResponse;
      let requestId;
      if (shareUrlId && isNewApiForShareUrlEnabled) {
        const {
          data,
          requestId: _requestId
        } = await installWithShareUrlId();
        installationResponse = data;
        requestId = _requestId;
      } else {
        const {
          data,
          requestId: _requestId
        } = await installWithAppId(oauth2);
        installationResponse = data;
        requestId = _requestId;
      }

      // Ignoring errors so we will have parity with the old installer
      if (!isEmpty(installationResponse.installErrors)) {
        panoramaLogger(JSON.stringify(installationResponse.installErrors), {
          requestId
        });
      }
      const {
        installedApps
      } = installationResponse;
      if (isEmpty(installedApps)) {
        reportInstallFailed(requestId);
        await handleError({
          error: new Error('Empty installed apps'),
          requestId,
          ...INSTALLER_ERRORS.INSTALLATION_FAILED
        });
        return;
      } else {
        const provisionSuccessData = convertResponseToProvisionSuccess({
          tenantId,
          mainInstalledAppId: appId,
          installedApps: installedApps
        });
        if (provisionSuccessData) {
          var _provisionSuccessData;
          await (onProvisionSuccess == null ? void 0 : onProvisionSuccess(provisionSuccessData));
          reportInstallSuccess({
            requestId,
            instanceId: ((_provisionSuccessData = provisionSuccessData.installedApps[0]) == null ? void 0 : _provisionSuccessData.instanceId) || ''
          });
        }
        setIsFinishLoading(true);
        await wait(500); // Sometime installation is very quick, and we don't want to show the loader for a very short time

        return provisionSuccessData;
      }
    } catch (error) {
      await handleError({
        error,
        ...INSTALLER_ERRORS.INSTALLATION_FAILED
      });
      return;
    }
  };
};
//# sourceMappingURL=useProvisionApp.js.map